@if (visible()) {
  <section
    class="zag-bulk-edit-job-toast"
    [attr.role]="terminalStatus() === 'failed' ? 'alert' : 'status'"
    [attr.aria-live]="terminalStatus() === 'failed' ? 'assertive' : 'polite'"
    aria-atomic="true"
  >
    <header class="zag-bulk-edit-job-toast__header">
      <span zagIcon="sync" class="zag-bulk-edit-job-toast__icon" aria-hidden="true"></span>
      <div class="zag-bulk-edit-job-toast__title-group">
        <span class="zag-bulk-edit-job-toast__title">{{ 'bulkEdit.inline.jobTitle' | translate }}</span>
        @if (job().propertyLabelKey; as propertyLabelKey) {
          <strong class="zag-bulk-edit-job-toast__property">{{ propertyLabelKey | translate }}</strong>
        }
      </div>
    </header>

    <div
      class="zag-bulk-edit-job-toast__progress"
      role="progressbar"
      [attr.aria-valuenow]="progress()"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-label]="'bulkEdit.inline.progress' | translate: { progress: progress(), total: job().total }"
    >
      <span class="zag-bulk-edit-job-toast__progress-bar" [style.width.%]="progress()"></span>
    </div>
    <span class="zag-bulk-edit-job-toast__progress-label">
      {{ 'bulkEdit.inline.progress' | translate: { progress: progress(), total: job().total } }}
    </span>

    @if (terminalStatus(); as status) {
      <p
        class="zag-bulk-edit-job-toast__terminal"
        [class.zag-bulk-edit-job-toast__terminal--finished]="status === 'finished'"
        [class.zag-bulk-edit-job-toast__terminal--failed]="status === 'failed'"
        [class.zag-bulk-edit-job-toast__terminal--cancelled]="status === 'cancelled'"
      >
        <span [zagIcon]="terminalIcon()" aria-hidden="true"></span>
        {{ 'bulkEdit.inline.status.' + status | translate }}
      </p>
    }

    <footer class="zag-bulk-edit-job-toast__actions">
      <button zagButton="outlined" zagType="secondary" zagSize="sm" type="button" (click)="dismiss()">
        {{ 'bulkEdit.inline.dismiss' | translate }}
      </button>
      <button zagButton="outlined" zagType="primary" zagSize="sm" type="button" (click)="showDetails()">
        {{ 'bulkEdit.inline.showDetails' | translate }}
      </button>
    </footer>
  </section>
}
